export default __webpack_public_path__ + "static/media/Claws of the Cackling Marionette.08ced1f5.jpg";